import React from 'react';
import { ShieldCheck, Users, Stethoscope, HeartHandshake } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const TrustSection = () => {
  const { t } = useLanguage();

  const trustItems = [
    { id: 'care', icon: Users, title: t('trust.item1'), description: t('trust.item1Desc') },
    { id: 'medical', icon: Stethoscope, title: t('trust.item2'), description: t('trust.item2Desc') },
    { id: 'safety', icon: ShieldCheck, title: t('trust.item3'), description: t('trust.item3Desc') },
    { id: 'results', icon: HeartHandshake, title: t('trust.item4'), description: t('trust.item4Desc') }
  ];

  return (
    <section className="py-20 md:py-28 bg-[#F0FDFA]" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm font-semibold tracking-wider uppercase text-[#009d9f] mb-4">
            {t('trust.tagline')}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {t('trust.title')}{' '}
            <span className="text-[#009d9f]">{t('trust.titleHighlight')}</span>
          </h2>
          <p className="text-lg text-slate-600">{t('trust.description')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-testid="trust-grid">
          {trustItems.map((item, index) => (
            <div
              key={item.id}
              className="bg-white rounded-2xl p-6 text-center shadow-sm border border-[#CCFBF1] hover:shadow-lg hover:border-[#14B8A6] transition-all duration-300"
              data-testid={`trust-item-${index}`}
            >
              <div className="w-16 h-16 rounded-full bg-[#CCFBF1] flex items-center justify-center mx-auto mb-5">
                <item.icon className="w-8 h-8 text-[#009d9f]" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
                {item.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[#009d9f] rounded-3xl p-8 md:p-12 text-center text-white" data-testid="guarantee-banner">
          <div className="max-w-2xl mx-auto">
            <ShieldCheck className="w-16 h-16 mx-auto mb-6 text-[#2DD4BF]" />
            <h3 className="text-2xl md:text-3xl font-bold mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              {t('trust.guaranteeTitle')}
            </h3>
            <p className="text-lg text-teal-100 leading-relaxed">{t('trust.guaranteeDesc')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
